import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AppProtectIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#ff9e0e' : this.getColor()
    return [
       <g transform="translate(-1 -1)">
        <path d="M34.24,16.25c-1-1-2.44-.44-3.42-1.42s-.44-2.44-1.42-3.41S27,11,26,10s-.26-2.48-1.31-3.53S22.2,6.2,21.15,5.16,20.8,2.7,19.79,1.69A2.86,2.86,0,0,0,18,1H4A3,3,0,0,0,1,4V32a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3V18.24a3.5,3.5,0,0,0-.76-1.99Z" fill={ color } />
        <circle cx="1.5" cy="1.5" r="1.5" transform="translate(26.6 6.4)" fill={ color } />
        <circle cx="1" cy="1" r="1" transform="translate(32 6.9)" fill={ color }/>
        <circle cx="1.5" cy="1.5" r="1.5" transform="translate(31.5 11.2)" fill={ color }/>
        <circle cx="0.5" cy="0.5" r="0.5" transform="translate(32.4 2.6)" fill={ color }/>
        <circle cx="1" cy="1" r="1" transform="translate(27.1 2.1)" fill={ color }/>
        <circle cx="1.5" cy="1.5" r="1.5" transform="translate(21.8 1.6)" fill={ color }/>
        <path d="M10.991,20.515V9.658l9.7-4.1V15.931ZM16.562,8.278l-1.38,1.38v6.9l1.38-1.38ZM-.016,4.084,10.27,0,20.681,4.074l-10.4,4.187ZM9.656,20.515.006,15.931V5.557l9.65,4.1ZM5.525,9.658l-1.38-1.38v6.9l1.38,1.38Z" transform="translate(7.317 11)" fill="#fff" fillRule="evenodd"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 34 34'
}
